<template>
  <div
    :class="[
      'torchlight-season-ranking',
      `torchlight-season-ranking-${lang}`,
      serverList.length < 2 && 'torchlight-season-ranking-single-server'
    ]"
    :style="{ 'background-image': `url(${isMobile ? mobileModalBg : modalBg})` }"
  >
    <div class="torchlight-season-ranking-top">
      <ul class="torchlight-season-ranking-server" v-if="serverList.length > 1">
        <li
          v-for="item in serverList"
          :class="['torchlight-season-ranking-server-item', sid === item.id && 'torchlight-season-ranking-server-active']"
          :key="item.id"
          :style="{ 'background-image': `url(${sid === item.id ? serverActiveBg : serverBg})` }"
          @click="onChangeServer(item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="torchlight-season-ranking-middle">
      <div class="torchlight-season-ranking-prev" @click="onPrev">
        <img :src="arrowBg" alt="prev button" />
      </div>
      <div class="torchlight-season-ranking-hero" ref="scrollerRef">
        <ul>
          <li
            v-for="item in heroList"
            :class="[heroPurchaseId === item.id && 'torchlight-season-ranking-hero-active']"
            :key="item.id"
            @click="onChangeHero(item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="torchlight-season-ranking-next" @click="onNext">
        <img :src="arrowBg" alt="next button" />
      </div>
    </div>
    <div class="torchlight-season-ranking-bottom">
      <div class="torchlight-season-ranking-title">{{ title }}</div>
      <div class="torchlight-season-ranking-table">
        <ul class="torchlight-season-ranking-table-head">
          <li v-for="item in columns" :key="item">{{ item }}</li>
        </ul>
        <ul class="torchlight-season-ranking-table-body">
          <li v-for="item in dataList" :key="item.id">
            <div>{{ item.ranking }}</div>
            <div>{{ item.role_name }}</div>
            <div>{{ item.level }}</div>
            <div>{{ item.role_total_time_str }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="loading" class="torchlight-season-ranking-loading">
      <img :src="loadingBg" alt="" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {
  defaultServers,
  defaultServersCN,
  defaultHeros,
  defaultTitle,
  defaultColumns,
} from './constant';
import Scroller from './scroller';

const API_CN = 'https://poster-api.xd.cn/api/v1.0/activity/torchlight/top';
const API_US = 'https://poster-api.xd.com/api/v1.0/activity/torchlight/top';

export default {
  name: 'TorchlightSeasonRanking',
  props: {
    apiUrl: String,
    season: {
      type: String,
      default: 's3',
    },
    lang: {
      type: String,
      default: 'us',
    },
    isOverSea: {
      type: Boolean,
      default: true,
    },
    servers: Object,
    heroes: Object,
    modalBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/s3_overseas/en/phase_3/section_2/pc/8UlMXL3V.png',
    },
    serverBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/s3_overseas/en/phase_3/section_2/pc/8UlpChG4.png'
    },
    serverActiveBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/s3_overseas/en/phase_3/section_2/pc/8UlpC0dz.png'
    },
    arrowBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/s3_overseas/en/phase_3/section_2/pc/8WdxBzvV.png',
    },
    loadingBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/s3_overseas/en/phase_3/section_2/pc/8W41kWzb.png',
    },
    mobileModalBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/s3_overseas/en/phase_3/section_2/pc/8WdVYR6L.png',
    },
  },

  data() {
    this.timer = null;
    this.resizeTimer = null;
    this.scroller = null;

    return {
      isMobile: false,
      loading: false,
      sid: '',
      heroPurchaseId: '',
      dataList: [],
    };
  },

  computed: {
    api() {
      return this.apiUrl ? this.apiUrl : this.isOverSea ? API_US : API_CN;
    },

    serverList() {
      let defaultServer = defaultServersCN;
      if (this.isOverSea) {
        defaultServer = defaultServers;
      }
      return (this.isObject(this.servers) ? this.servers[this.lang] : defaultServer[this.lang]) || [];
    },

    heroList() {
      return (this.isObject(this.heroes) ? this.heroes[this.lang] : defaultHeros[this.lang]) || [];
    },

    title() {
      return defaultTitle[this.lang];
    },

    columns() {
      return defaultColumns[this.lang];
    },
  },

  watch: {
    sid() {
      this.refresh();
    },

    heroPurchaseId() {
      this.refresh();
    },
  },

  mounted() {
    this.listenResize();
    this.init();
    this.scroller = new Scroller();
  },

  destroyed() {
    this.removeListenr();
    this.clearTimer();
  },
  
  methods: {
    isObject(target) {
      return Object.prototype.toString.call(target) === '[object Object]';
    },

    listenResize() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    },
    removeListenr() {
      window.removeEventListener('resize', this.handleResize);
    },

    handleResize() {
      this.clearTimer();
      this.resizeTimer = setTimeout(() => {
        this.isMobile = window.innerWidth <= 1024;
      }, 50);
    },

    clearTimer() {
      this.resizeTimer && clearTimeout(this.resizeTimer);
    },

    init() {
      const defaultServer = this.serverList[0];
      const defaultHero = this.heroList[0];
      if (defaultServer && defaultHero) {
        this.sid = defaultServer.id;
        this.heroPurchaseId = defaultHero.id;
        this.refresh();
      }
    },

    refresh() {
      this.timer && clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.loading = true;
        
        this.getList()
          .then((data) => {
            let result = data.splice(0, 10);
            if (result < 1) {
              for (let i = 1; i <= 10; i++) {
                result.push({
                  level: '-',
                  ranking: i,
                  role_id: '-',
                  role_name: '-',
                  role_total_time_str: '-'
                });
              }
            }
            this.dataList = result;
          })
          .finally(() => {
            this.loading = false;
          });
      }, 200);

    },

    getList() {
      return axios.get(this.api, {
        params: {
          sid: this.sid,
          season: this.season,
          hero_purchase_id: this.heroPurchaseId,
        }
      }).then((res) => {
        return res && res.data || [];
      }).catch(() => {
        return [];
      });
    },

    onChangeServer(id) {
      this.sid = id;
    },

    onChangeHero(id) {
      this.heroPurchaseId = id;
    },

    onPrev() {
      const refEl = this.$refs.scrollerRef;
      this.scroller.toPrevStep(refEl, refEl.clientWidth);
    },

    onNext() {
      const refEl = this.$refs.scrollerRef;
      this.scroller.toNextStep(refEl, refEl.clientWidth);
    },
  },
}
</script>

<style lang="scss" scoped>
$font-weight-bold: 900;
$font-weight-medium: 500;
$font-weight-regular: 400;
$primary-color: #FF4E61;
$primary-border-color: #724346;
$active-color: #ffffff;
$text-color: #898B95;
$text-active-color: #D2D2D2;
$shadow-color: #FF0000;
$primary-active-color: #A32F3B;
$primary-bg-color: rgba(49, 0, 5, 0.4);
$primary-bg-color-light: rgba(49, 0, 5, 0.3);
$mask-bg-color: rgba(0,0,0,0.5);

@function vwPC($px) {
  @return calc($px/2048) * 100vw;
}

@function vwMobile($px) {
  @return calc($px/1024) * 100vw;
}

.torchlight-season-ranking {
  position: relative;
  width: vwPC(1104);
  height: vwPC(783);
  background-size: 100% 100%;
  background-repeat: no-repeat;

  li {
    list-style: none;
  }

  img {
    user-select: none;
  }

  &-single-server {
    .torchlight-season-ranking-top {
      height: vwPC(20);
    }
    .torchlight-season-ranking-middle {
      margin: 0 0 vwPC(64) 0;
    }
  }

  &-loading {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $mask-bg-color;

    img {
      width: vwPC(65);
      height: vwPC(68);
      animation: rotate 4.2s linear infinite;
    }
  }

  &-top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    padding: vwPC(20) 0 vwPC(16) 0;
  }

  &-server {
    display: flex;
    width: vwPC(850);
    align-items: center;
    justify-content: space-between;

    &-item {
      width: vwPC(216);
      height: vwPC(52);
      line-height: vwPC(52);
      font-size: vwPC(26);
      font-weight: $font-weight-bold;
      text-align: center;
      color: $primary-color;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: transform .2s ease-in-out;

      &:hover {
        transform: translateY(-2px);
      }
    }

    &-active {
      color: $active-color;
    }
  }

  &-middle {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 0 vwPC(26);
    box-sizing: border-box;
  }

  &-prev,
  &-next {
    display: flex;
    align-items: center;
    justify-content: center;
    width: vwPC(32);
    height: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    cursor: pointer;
    transition: transform .2s ease-in-out;

    img {
      display: block;
      width: vwPC(12);
      height: vwPC(20);
    }
  }

  &-prev {
    &:hover {
      transform: translateX(-2px);
    }
  }

  &-next {
    &:hover {
      transform: translateX(2px);
    }

    img {
      transform: rotate(180deg);
      transform-origin: center center;
    }
  }

  &-hero {
    width: vwPC(992);
    flex-grow: 1;
    flex-shrink: 1;
    overflow-x: auto;
    overflow-y: hidden;
    border: vwPC(2) solid $primary-border-color;
    scrollbar-width: 0;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    & > ul {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      & > li {
        position: relative;
        padding: vwPC(12) vwPC(16);
        flex-grow: 0;
        flex-shrink: 0;
        color: $text-color;
        font-weight: $font-weight-medium;
        font-size: vwPC(16);
        cursor: pointer;
        transition: color .2s ease-in-out;

        &:hover {
          color: $active-color;
        }

        &::after {
          content: "";
          display: block;
          position: absolute;
          bottom: vwPC(-2);
          left: 50%;
          width: 0;
          height: 0;
          transform: translateX(-50%);
          background: $primary-active-color;
          transition: all .2s ease-in-out;
        }

        &.torchlight-season-ranking-hero-active {
          color: $active-color;
          text-shadow: 0 0 vwPC(4) $shadow-color;

          &::after {
            width: 50%;
            height: vwPC(4);
          }
        }
      }
    }
  }

  &-bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: vwPC(32);
  }

  &-title {
    width: vwPC(992);
    height: vwPC(64);
    line-height: vwPC(64);
    text-align: center;
    background-color: $primary-bg-color;
    border: vwPC(2) solid $primary-active-color;
    color: $primary-color;
    font-size: vwPC(26);
    font-weight: $font-weight-bold;
  }

  &-table {
    width: vwPC(992);
    background-color: $primary-bg-color-light;
    border: vwPC(2) solid $primary-active-color;
    border-top: none;
  }

  &-table-head {
    display: flex;
    flex-direction: row;
    border-bottom: vwPC(2) solid $primary-active-color;
    color: $primary-color;
    font-size: vwPC(21);
    font-weight: $font-weight-medium;

    & > li {
      height: vwPC(58);
      line-height: vwPC(58);
      text-align: center;

      &:nth-of-type(1) {
        width: 19%;
      }
      &:nth-of-type(2) {
        width: 41%;
      }
      &:nth-of-type(3) {
        width: 16%;
      }
      &:nth-of-type(4) {
        width: 24%;
      }
    }
  }

  &-table-body {
    min-height: vwPC(460);

    & > li {
      display: flex;
      flex-direction: row;
      color: $text-active-color;
      font-size: vwPC(21);
      font-weight: $font-weight-regular;

      & > div {
        height: vwPC(46);
        line-height: vwPC(46);
        padding: 0 vwPC(16);
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
  
        &:nth-of-type(1) {
          width: 19%;
        }
        &:nth-of-type(2) {
          width: 41%;
        }
        &:nth-of-type(3) {
          width: 16%;
        }
        &:nth-of-type(4) {
          width: 24%;
        }
      }
    }
  }
}

@media screen and (max-width: 1920px) {
  .torchlight-season-ranking {
    width: 1024px;
    height: 726px;

    &-single-server {
      .torchlight-season-ranking-middle {
        margin: 18px 0 54px 0;
      }
    }

    &-loading {
      img {
        width: 62px;
        height: 65px;
      }
    }

    &-top {
      padding: 18px 0 14px 0;
    }

    &-server {
      width: 792px;

      &-item {
        width: 202px;
        height: 48px;
        line-height: 48px;
        font-size: 24px;
      }
    }

    &-middle {
      padding: 0 26px;
    }

    &-prev,
    &-next {
      width: 27px;

      img {
        width: 11px;
        height: 18px;
      }
    }

    &-hero {
      width: 930px;
      border-width: 2px;

      & > ul {
        & > li {
          padding: 12px 16px;
          font-size: 15px;

          &::after {
            bottom: -2px;
          }

          &.torchlight-season-ranking-hero-active {
            text-shadow: 0 0 4px $shadow-color;

            &::after {
              height: 4px;
            }
          }
        }
      }
    }

    &-bottom {
      margin-top: 24px;
    }

    &-title {
      width: 930px;
      height: 57px;
      line-height: 57px;
      border-width: 2px;
      font-size: 24px;
    }

    &-table {
      width: 930px;
      border-width: 2px;
    }

    &-table-head {
      border-bottom-width: 2px;
      font-size: 20px;

      & > li {
        height: 54px;
        line-height: 54px;
      }
    }

    &-table-body {
      min-height: 440px;

      & > li {
        font-size: 20px;

        & > div {
          height: 44px;
          line-height: 44px;
          padding: 0 16px;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .torchlight-season-ranking {
    width: vwMobile(968);
    height: vwMobile(1137);

    &-single-server {
      .torchlight-season-ranking-top {
        padding: 0;
      }
      .torchlight-season-ranking-middle {
        margin: vwMobile(66) 0 vwMobile(66) 0;
      }
    }

    &-loading {
      img {
        width: vwMobile(72);
        height: vwMobile(76);
      }
    }

    &-top {
      padding: vwMobile(53) 0 vwMobile(33) 0;
    }

    &-server {
      width: vwMobile(890);

      &-item {
        width: vwMobile(278);
        height: vwMobile(68);
        line-height: vwMobile(68);
        font-size: vwMobile(34);
      }
    }

    &-middle {
      padding: 0 vwMobile(8);
    }

    &-prev,
    &-next {
      width: vwMobile(100);

      img {
        width: vwMobile(45);
        height: vwMobile(72);
      }
    }

    &-hero {
      width: 728px;
      border-width: vwMobile(3);

      & > ul {
        & > li {
          padding: vwMobile(18) vwMobile(24);
          font-size: vwMobile(29);

          &::after {
            bottom: vwMobile(-4);
          }

          &.torchlight-season-ranking-hero-active {
            text-shadow: 0 0 vwMobile(4) $shadow-color;

            &::after {
              height: vwMobile(8);
            }
          }
        }
      }
    }

    &-bottom {
      margin-top: vwMobile(24);
    }

    &-title {
      width: vwMobile(890);
      height: vwMobile(96);
      line-height: vwMobile(96);
      border-width: vwMobile(3);
      font-size: vwMobile(34);
    }

    &-table {
      width: vwMobile(890);
      border-width: vwMobile(3);
    }

    &-table-head {
      border-bottom-width: vwMobile(3);
      font-size: vwMobile(30);

      & > li {
        height: vwMobile(86);
        line-height: vwMobile(86);
      }
    }

    &-table-body {
      min-height: vwMobile(640);

      & > li {
        font-size: vwMobile(30);

        & > div {
          height: vwMobile(64);
          line-height: vwMobile(64);
          padding: 0 vwMobile(16);
        }
      }
    }

    &-jp {
      .torchlight-season-ranking-table-head > li {
        font-size: vwMobile(20);
      }
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
    transform-origin: center center;
  }
  100% {
    transform: rotate(360deg);
    transform-origin: center center;
  }
}
</style>